import { Injectable } from '@angular/core';
import { BrowserStorageKey } from '@mavles/data';

@Injectable({ providedIn: 'root' })
export class AuthSessionService {

  // Token is stored as a plain key (not user-namespaced) so it can be read before user is loaded
  private readonly TOKEN_KEY = BrowserStorageKey.Token.toString();

  saveToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, JSON.stringify(token));
  }

  getToken(): string | undefined {
    const raw = localStorage.getItem(this.TOKEN_KEY);
    if (!raw) return undefined;
    try {
      return JSON.parse(raw) as string;
    } catch {
      return raw; // stored as plain string fallback
    }
  }

  clearSession(): void {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(BrowserStorageKey.User.toString());
  }
}
